import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParentObject } from 'src/app/shared-components/components/notes-list/notes.model';
import { DocumentsList, DocumentsListFilters } from './visit-documents.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';
import { mapToHttpParams } from '@bcl/common-ui';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentsListApiService {
  constructor(private readonly http: HttpClient) {}

  public getDocumentsList(
    parentObject: ParentObject,
    parentId: string,
    pageNumber: number,
    pageSize: number,
    filters: DocumentsListFilters
  ): Observable<DocumentsList> {
    const url = `${environment.apiHost}/files`;
    const params = mapToHttpParams({
      parentObject,
      parentId,
      pageNumber,
      pageSize,
      searchText: filters.searchText,
    });

    return this.http.get<DocumentsList>(url, { params });
  }

  public downloadFile(id: string): Observable<Blob> {
    const url = `${environment.apiHost}/files/${id}`;
    return this.http.get(url, { responseType: 'blob' });
  }
  public async downloadFileToDisk(blob: Blob, fileName: string) {
    try {
      const base64Data = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64 = reader.result as string;
          resolve(base64.split(',')[1]);
        };
        reader.readAsDataURL(blob);
      });
      if (Capacitor.getPlatform() === 'ios') {
        await Filesystem.writeFile({
          path: fileName,
          data: base64Data,
          directory: Directory.External,
          recursive: true,
        });
      } else {
        await Filesystem.writeFile({
          path: fileName,
          data: base64Data,
          directory: Directory.Documents,
          recursive: true,
        });
      }
    } catch (error) {
      console.error('Error saving file:', error);
      throw error;
    }
  }
  public openFileInNewTab(blob: Blob): void {
    const fileURL = URL.createObjectURL(blob);
    window.open(fileURL);
  }
}
